import { render, staticRenderFns } from "./ExtraActions.vue?vue&type=template&id=14a7a67e&lang=pug&"
import script from "./ExtraActions.vue?vue&type=script&lang=ts&"
export * from "./ExtraActions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports